<template>
    <jet-modal :show="show" :closeable="false" max-width="sm">
        <div class="p-6">
            <div class="flex items-start">
                <div class="flex-shrink-0">
                    <svg class="h-6 w-6 text-red-600" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                    </svg>
                </div>
                <div class="ml-3 flex-1">
                    <h3 class="text-lg font-medium text-gray-900">Cart Update Error</h3>
                    <p class="mt-2 text-sm text-gray-500">Something went wrong when updating your cart. Please refresh and try again.</p>
                    <div class="mt-4 flex gap-x-3">
                        <jet-tertiary @click="refreshPage">
                            Refresh Page
                        </jet-tertiary>
                    </div>
                </div>
            </div>
        </div>
    </jet-modal>
</template>

<script>
import JetModal from '@/Jetstream/Modal.vue';
import JetTertiary from '@/Jetstream/TertiaryButton.vue';

export default {
    name: 'CartErrorModal',
    components: {
        JetModal,
        JetTertiary,
    },
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        refreshPage() {
            window.location.reload();
        }
    }
}
</script> 